// GENERATED FILE - do not edit.
// Emitted by tools/generate-wire-schemas.mjs from
// Server/src/Shared/Server/Resources/openapi.json (the spec lockfile).
// Regenerate with: npm run generate:wire
//
// Base wire shape for the server "Tag" component. The corresponding
// *.schema.ts is the facade that names it (and hosts any future refinement);
// see design/wiki/wire-schemas.md.
import { z } from "zod";
import { TagType } from "./tag-type.enum.gen";

export const TagGenShape = z.strictObject({
  name: z.string(),
  description: z.string().optional(),
  tagType: z.enum(TagType),
  useCount: z.number(),
  order: z.number(),
  groupId: z.string().optional(),
  keywords: z.string().optional(),
  libraryId: z.string(),
  created: z.string().optional(),
  createdUserId: z.string().optional(),
  lastEdited: z.string().optional(),
  lastEditedUserId: z.string().optional(),
  id: z.string(),
});
